import { cloneDeep } from 'lodash'
import { emptyTimeTable } from "../timetable/timetable"

const voucherDescription = `Apreciado **$Nombre**,

Gracias por contactar con nosotros para reservar su **$Actividad**.

Le confirmamos su reserva con los siguientes datos:

Fecha: **$Fecha**

Hora: **$Hora**

Dirección: **$Direccion**

Teléfono: **$Telefono**

Por favor, presente esta reserva a su llegada a **$Actividad**.`

const emptyActivity = {
  _id: null,
  title: "",
  name: "",
  address: "",
  phoneNumber : "",
  preciseLocation: {
    address: "",
    latitude: null,
    longitude: null
  },
  englishName: "",
  city: "Madrid",
  duration: 0,
  preferences: [],
  price: { general: 0, kids: null }, // Price.js::emptyPrice
  cost: { general: 0, kids: null },
  files: { doc1Page: null, activityImg: null, ticketExample: null },
  fileNotes: {},
  voucherFiles: { image1: null, image2: null },
  voucherFileNotes: {},
  hasVoucher: false,
  voucherDescription,
  recommendedTransportation: "PUBLIC_TPT",
  recommendedTransportationOther: "",
  transportationOptions: [],
  transportationOptionsOther: "",
  supplier: null,

  description: "",
  longDescription: "",
  notes: "",
  notesForAgencies: "",

  clientNote: "",
  visitInstructions: "",
  restaurant:{
    background: { image: null },
    menus: {},
    drinks: {}
  },
  reservationNote: "",
  reservationPhone: "",
  reservationMail: "",

  tags: {},

  alwaysOpen: false,
  unknownAvailability: true,
  timetable: cloneDeep(emptyTimeTable),
}

export default emptyActivity
